import Loading from "./LoadingSpinner";
import { OPEN } from "../../ducks/loadingSpinner";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
  return {
    [OPEN]: state.loading[OPEN]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Loading);
